import moment, { Moment } from 'moment-timezone';
import { LegFiJwtService } from '../services/auth/legfi-jwt.service';

export function setDate(date: string|null = null): Moment {
    const timezone = LegFiJwtService.getTimezone();
    return date ?
        moment.utc(date, 'YYYY-MM-DD hh:mm:ss').tz(timezone) :
        null;
}
